import * as yup from 'yup';
import { NewsStatus } from '@/entities/news/news-status.enum';

export const newsEditSchema = yup.object({
  title: yup.string().required(),
  content: yup.string().required(),
  status: yup.string().oneOf(Object.values(NewsStatus)).required(),
});
